module.exports = __webpack_public_path__ + "static/media/step-3.9907f17d.png";